var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isLoading
      ? _c("div", { staticClass: "loading-card-wrapper bg-black" })
      : this.campaignExist
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "carousel slide",
              attrs: {
                id: "aoneCarouselControls",
                "data-ride": "carousel",
                "data-interval": "false"
              }
            },
            [
              _vm.formattedCampaigns.length > 1
                ? _c(
                    "ol",
                    { staticClass: "carousel-indicators" },
                    _vm._l(_vm.formattedCampaigns.length, function(_, i) {
                      return _c("li", {
                        key: i,
                        class: { active: i === 0 },
                        attrs: {
                          "data-target": "#aoneCarouselControls",
                          "data-slide-to": i
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCarouselControlClick(
                              "slide indicator"
                            )
                          }
                        }
                      })
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "carousel-inner" },
                _vm._l(_vm.formattedCampaigns, function(campaign, i) {
                  return _c(
                    "div",
                    {
                      key: campaign.id,
                      staticClass: "carousel-item",
                      class: { active: i === 0 }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "campaign-card-wrapper d-flex align-items-center",
                          style: _vm.getBackgroundStyle(campaign)
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "campaign-container container" },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-xl-10 pb-4" },
                                  [
                                    _c("div", { staticClass: "mb-4" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "campaign-title text-overflow-ellipsis"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(campaign.bannerTitle) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      campaign.bannerSubTitle
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "campaign-sub-title text-overflow-ellipsis mt-2"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    campaign.bannerSubTitle
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      campaign.bannerLink &&
                                      campaign.bannerLink.url
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "campaign-btn",
                                              on: {
                                                click: function($event) {
                                                  return _vm.navigateToCampaignPost(
                                                    campaign
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              campaign.bannerType ===
                                              _vm.CONSTANTS.LUMI_CAMPAIGN_BANNER
                                                ? _c("img", {
                                                    staticClass:
                                                      "lumi-campaign-image",
                                                    attrs: {
                                                      src: require("@/assets/image/lumi-character.png"),
                                                      alt: "Lumi"
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    campaign.bannerLink
                                                      ? campaign.bannerLink
                                                          .description
                                                      : ""
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.formattedCampaigns.length > 1
                ? _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "carousel-control-prev",
                        attrs: {
                          href: "#aoneCarouselControls",
                          role: "button",
                          "data-slide": "prev"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCarouselControlClick("previous")
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass:
                            "chevron-left-icon fa-lg carousel-controls-arrow",
                          attrs: { icon: ["fas", "chevron-left"] }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Previous")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "carousel-control-next",
                        attrs: {
                          href: "#aoneCarouselControls",
                          role: "button",
                          "data-slide": "next"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCarouselControlClick("next")
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass:
                            "chevron-left-icon fa-lg carousel-controls-arrow",
                          attrs: { icon: ["fas", "chevron-right"] }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [_vm._v("Next")])
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        ])
      : _c("div", [
          _c(
            "div",
            {
              staticClass: "greeting-card-wrapper",
              style: _vm.backgroundStyle
            },
            [
              _c("div", { staticClass: "campaign-container container" }, [
                _c("div", { staticClass: "campaign-title text-left" }, [
                  _c("div", [_vm._v(_vm._s(_vm.homepageHeaderGreeting))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "greeting text-left" }, [
                  _c("div", [
                    _vm._v(_vm._s(_vm.CONSTANTS.HOMEPAGE_GENERIC_GREETING))
                  ])
                ])
              ])
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1014fc7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1014fc7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/CampaignCard.vue
// module id = null
// module chunks = 